




























import { Component, Vue, Inject, Ref } from 'vue-property-decorator';

import TipologiaservizioList from './TipologiaservizioList.vue';
import EditTipologiaservizio from './tipologiaservizio/EditTipologiaservizio.vue';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaservizio } from '@/data/models/tipologiaservizio.model';
import TipologiaservizioFilter from './TipologiaservizioFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { BModalComponent } from 'buefy/types/components';

@Component({
	components: {
		TipologiaservizioList,
		EditTipologiaservizio,
		TipologiaservizioFilter,
	},
})
export default class Tipologieservizio extends Vue {
	@Inject('CrudService') crudService!: CrudService<Tipologiaservizio>;

	@Ref('list') list!: TipologiaservizioList;
	@Ref('filter') filter!: TipologiaservizioFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadTipologieservizio();
	}

	saveTipologiaservizio(value: Tipologiaservizio, modal: BModalComponent) {
		
		this.crudService
			.createEntity(Tipologiaservizio, 'tipologiaservizio', value)
			.then(() => {
				this.list.loadTipologieservizio();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	addTipologiaservizio() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditTipologiaservizio,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Tipologiaservizio) => {
					this.saveTipologiaservizio(value, modal);
				},
			},
		});
	}

	editTipologiaservizio(item: Tipologiaservizio) {
		this.openTipologiaservizio(item);
	}

	openTipologiaservizio(item: Tipologiaservizio) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditTipologiaservizio,
			props: {
				tipologiaservizio: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Tipologiaservizio) => {
					this.saveTipologiaservizio(value, modal);
				},
			},
		});
	}

	deleteTipologiaservizio(item: Tipologiaservizio) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-tipologiaservizio-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Tipologiaservizio, 'tipologiaservizio', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadTipologieservizio();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
